import { ENV } from '@shared/config/env';

//Конфигурация API клиента
export const API_CONFIG = {
  baseURL: ENV.VITE_API_BASE_URL,
  timeout: ENV.VITE_API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
} as const;

// Эндпоинты API
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },

  // Users
  USERS: {
    BASE: '/users',
    BY_ID: (id: string) => `/users/${id}`,
    PROFILE: '/users/profile',
  },

  // Questions
  QUESTIONS: {
    BASE: '/questions',
    BY_ID: (id: string) => `/questions/${id}`,
    RANDOM: '/questions/random',
  },

  // Courses
  COURSES: {
    BASE: '/courses',
    BY_ID: (id: string) => `/courses/${id}`,
    SUBSCRIBE: (id: string) => `/courses/${id}/subscribe`,
  },

  // Progress
  PROGRESS: {
    BASE: '/progress',
    STATS: '/progress/stats',
    HISTORY: '/progress/history',
  },
} as const;
